import { Stack, Box } from "@chakra-ui/react"
import { Checkbox } from "../../../ui/checkbox"
import useStore from "../../../../store"
import FilterButtons from "../../Dealers/DealerTableFiltering/FilterButtons"
import ReusableDrawer from "../../../common/ReusableDrawer"
import { colors } from "../../../../utilities/colors"

export default function UnitsFilterByDrawer({ onClose, isOpen }) {
  const setAmUnitsTableParams = useStore((state) => state.setAmUnitsTableParams)
  const amUnitsTableParams = useStore((state) => state.amUnitsTableParams)
  const unitsFetching = useStore((state) => state.unitsFetching)
  const dealerUnitsResultsCount = useStore((state) => state.dealerUnitsPaginationData.dealerUnitsResultsCount)
  const setSelectedDealerUnitsScopeLabel = useStore((state) => state.setSelectedDealerUnitsScopeLabel)
  const setDealerUnitsPage = useStore((state) => state.setDealerUnitsPage)

  const handleResetFilter = () => {
    setAmUnitsTableParams('')
    setDealerUnitsPage(1)
    onClose()
  }

  const handleFilterByScope = (scope, label) => {
    setDealerUnitsPage(1)
    const currentScope = amUnitsTableParams['filter[scope]']

    if (currentScope === scope) {
      setAmUnitsTableParams('')
    } else {
      setSelectedDealerUnitsScopeLabel(label)
      setAmUnitsTableParams({
        [`filter[scope]`]: scope
      })
    }
  }

  return(
    <ReusableDrawer
    isOpen={isOpen}
    onClose={onClose}
    bgColor={colors.deepOcean}
    title="Filter Units"
    placement={'end'}
    bodyContent={
      <Box divideY={1} divideColor={colors.grey300} p={4}>
        <Stack>
          <Checkbox
            checked={amUnitsTableParams['filter[scope]'] === "untouched_60_plus_days"}
            onCheckedChange={() => handleFilterByScope("untouched_60_plus_days", "Untouched 60+ Days")}
          >
            Units Untouched 60+ Days
          </Checkbox>
          <Checkbox
            checked={amUnitsTableParams['filter[scope]'] === "past_due"}
            onCheckedChange={() => handleFilterByScope("past_due", "Past Due")}
          >
            Past Due Units
          </Checkbox>
          <Checkbox
            checked={amUnitsTableParams['filter[scope]'] === "repo"}
            onCheckedChange={() => handleFilterByScope("repo", "Repo Units")}
          >
            Repo Units
          </Checkbox>
          <Checkbox
            checked={amUnitsTableParams['filter[scope]'] === "sold"}
            onCheckedChange={() => handleFilterByScope("sold", "Sold Units")}
          >
            Sold Units
          </Checkbox>
        </Stack>
      </Box>
    }
    footerContent={
      <FilterButtons
        handleResetFilter={handleResetFilter}
        handleSubmit={() => onClose()}
        resultsCount={dealerUnitsResultsCount}
        resultsFetching={unitsFetching}
      />
    }
  />
  )
}